
export default class HeaderContentController {

    constructor($scope) {
        let vm = this;
        vm.pageTitle = 'Header Content';



    }

}

HeaderContentController.$inject = [
    '$scope'
];


// WEBPACK FOOTER //
// ./src/app/views/header-content/header-content.controller.js